import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonTitle from '../../../common-components/common-title';

const Ciphers = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} caseName="gens-ciphers">
                <div className="gens-ciphers__wrapper">
                    <CommonTitle className="gens-ciphers__title">Цифры</CommonTitle>
                    <div className="gens-ciphers__data-container">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={50}
                            animateOnce={true}
                            delay={100}
                            duration={1}
                            className="gens-ciphers__data-item"
                        >
                            <div className="gens-ciphers__data-title">6000+</div>
                            <CommonSmallText className="gens-ciphers__data-subtitle">
                                часов технической поддержки и развития
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="gens-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={50}
                            animateOnce={true}
                            delay={200}
                            duration={1}
                            className="gens-ciphers__data-item"
                        >
                            <div className="gens-ciphers__data-title">4</div>
                            <CommonSmallText className="gens-ciphers__data-subtitle">
                                года успешного сотрудничества
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="gens-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={50}
                            animateOnce={true}
                            delay={300}
                            duration={1}
                            className="gens-ciphers__data-item"
                        >
                            <div className="gens-ciphers__data-title">28</div>
                            <CommonSmallText className="gens-ciphers__data-subtitle">
                                завершенных акселераторов и&nbsp;треков
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="gens-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={50}
                            animateOnce={true}
                            delay={400}
                            duration={1}
                            className="gens-ciphers__data-item"
                        >
                            <div className="gens-ciphers__data-title">16000+</div>
                            <CommonSmallText className="gens-ciphers__data-subtitle">
                                принятых заявок за время работы платформы
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="gens-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Ciphers;
